import {Component, EventEmitter, Inject, OnInit, Output} from 'ng-metadata/core';
import {ChangeTabEvent, OPAC_TAB} from '../search/fullView/getit/opac/opac.directive';
import {LimitedHistoryStack} from '../infra/dataStructures/collections/stack/limitedHistoryStack.structure';
import {OpacService} from '../search/fullView/getit/opac/opac.service';
import {RequestService} from '../search/fullView/getit/opac/request/request.service';
import {MediaQueries} from "../infra/mediaQueries.service";
import {ReportProblemService} from "../reportProblem/reportProblem.service";

@Component({
    selector: 'prm-blank-purchase-request',
    templateUrl: 'components/purchaseRequest/purchase_request.html'
})

export class PrmPurchaseRequest implements OnInit{

    @Output()   private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();

    public backToHistoryStack: LimitedHistoryStack<OPAC_TAB>;
    private defaultTab = OPAC_TAB.REQUEST;
    private _selectedTab:OPAC_TAB;
    private BACK_HISTORY_SIZE :number = 12;
    private service;

    constructor(private requestService : RequestService,
                private opacService : OpacService,
                private mediaQueries: MediaQueries,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private reportProblemService: ReportProblemService) {
        this.backToHistoryStack = new LimitedHistoryStack<OPAC_TAB>(this.BACK_HISTORY_SIZE);
        this._selectedTab = this.defaultTab;
    }

    public getRequestIsLoading(){
        return this.requestService.requestIsLoading;
    }
    public onChangeTabEvent($event){
        let eventData:ChangeTabEvent = $event;

        if($event === null){
            this.selectedTab = this.backToHistoryStack.pop() || this.defaultTab;
        } else {
            if(eventData.referer !== undefined) {
                this.backToHistoryStack.push(eventData.referer);
            }
            if (eventData.service) {
                this.service = eventData.service;
            }
            this.selectedTab = eventData.dest;
        }
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(selectedTab) {
        this._selectedTab = selectedTab;
    }

    get responseStatus() {
        return this.opacService.responseStatus;
    }

    public getResponseMessage(){
        return this.opacService.getResponseMessage();
    }

    get displayErrorMessage() {
        return this.requestService.displayErrorMessage;
    }

    private getFormAccessibilityAlert(){
        if (this.$translate.isReady()) {
            if (this.selectedTab === OPAC_TAB.APPROVAL) {
                return this.$translate.instant('almaPurchaseRequest.isbnExist') + ' ' +
                    this.$translate.instant('almaPurchaseRequest.submit');
            }
            if (this.selectedTab === OPAC_TAB.RESPONSE) {
                return this.$translate.instant(this.getResponseMessage());
            }
        }
        return undefined;
    }

    public isReportProblem() {
        return this.reportProblemService.isReportProblem();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/purchaseRequest/purchaseRequest.directive.ts